import { identityAccountId, IdentityAccountId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { IAMAccountIdentity } from "../interface";
import { iamAccountIdentity } from "../schema";

export class IAMAccountUpdateCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountUpdateCmd.validationSchema()
  );

  constructor(readonly value: IAMAccountUpdateCmdRaw) {
    JsonSchemaValidator.assert(IAMAccountUpdateCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId", "identity"],
      properties: {
        accountId: identityAccountId,
        identity: iamAccountIdentity
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountUpdateCmdRaw {
  accountId: IdentityAccountId;
  identity: IAMAccountIdentity;
}
